import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Preset,
  UserCpuResult,
  QuotaAndGroupUsage,
  WebsiteGroupBandwidthUsage,
} from '../../shared/models/usage.models';

@Injectable({
  providedIn: 'root',
})
export class UsageService {
  private http = inject(HttpClient);

  getCpuUsage(userId: string, range: Preset): Observable<UserCpuResult> {
    // base url service is /cpu, so endpoint below becomes: /cpu/usage?range=24h
    return this.http.get<UserCpuResult>(`/cpu/${userId}`, {
      params: { preset: range },
    });
  }

  getDiskUsageByGroup(groupId: number): Observable<QuotaAndGroupUsage> {
    return this.http.get<QuotaAndGroupUsage>(`/disk-usage/usage`, {
      params: { groupId: groupId },
    });
  }

  getDiskUsageBySystemUser(systemUserId: number): Observable<QuotaAndGroupUsage> {
    return this.http.get<QuotaAndGroupUsage>(`/disk-usage/usage`, {
      params: { systemUserId: systemUserId },
    });
  }

  syncWebsiteGroupDiskUsageByGroupId(groupId: number): Observable<void> {
    return this.http.post<void>(`/disk-usage/usage`, {
      groupId: groupId,
    });
  }

  getBandwidthUsageByGroup(groupId: number, from: number): Observable<WebsiteGroupBandwidthUsage> {
    return this.http.get<WebsiteGroupBandwidthUsage>('/bandwidth/usage', {
      params: { groupId, from },
    });
  }
}
